import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import OverviewRowSkeleton from "./OverviewRowSkeleton";

const ROW_COUNT = 5;

const OverviewSkeleton = () => (
  <Card className="flex h-full w-full flex-col overflow-hidden rounded-xl border-border/70 bg-card/95 shadow-sm p-0">
    <CardHeader className="space-y-2 border-b px-3 py-2.5">
      <div className="flex items-center justify-between gap-2">
        <Skeleton className="h-5 w-56" />
        <Skeleton className="h-7 w-44 rounded-full" />
      </div>
      <Skeleton className="h-3 w-80" />
    </CardHeader>
    <CardContent className="space-y-3 p-3">
      <Skeleton className="h-9 w-full" />
      <div className="space-y-2">
        {Array.from({ length: ROW_COUNT }).map((_, i) => (
          <OverviewRowSkeleton key={i} />
        ))}
      </div>
    </CardContent>
  </Card>
);

export default OverviewSkeleton;
